<template>
  <div>
    <b-list-group>
      <b-list-group-item v-for="(item, index) in questions" :key="index" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <span v-if="item.question_prestart.type === 'THREE_CHOICES'">
            <i class="fa fa-commenting" aria-hidden="true"></i>
            {{ item.question_prestart.question }}
            <div class="text-muted answer-text">
              <i class="fa fa-comment"></i>
              {{ item.answer }}
            </div>
          </span>
          <span v-else-if="item.question_prestart.type === 'FILL'">
            <i class="fa fa-pencil" aria-hidden="true"></i>
            {{ item.question_prestart.question }}
            <div class="text-muted answer-text">
              <i class="fa fa-comment"></i>
              {{ item.answer }}
            </div>
          </span>
          <span v-else-if="item.question_prestart.type === 'MULTI_CHOICE'">
            <i class="fa fa-check-square" aria-hidden="true"></i>
            {{ item.question_prestart.question }}
            <div class="text-muted answer-text">
              <i class="fa fa-comment"></i>
              {{ item.answer }}
            </div>
          </span>
          <span v-else-if="item.question_prestart.type === 'CHOICE'">
            <i class="fa fa-dot-circle-o" aria-hidden="true"></i>
            {{ item.question_prestart.question }}
            <div class="text-muted answer-text">
              <i class="fa fa-comment"></i>
              {{ item.answer }}
            </div>
          </span>
          <h6>
            <b-badge v-if="item.status === 'SUCCESS'" variant="success" pill>PASS</b-badge>
            <b-badge v-else variant="danger" pill>FAIL</b-badge>
          </h6>
        </div>
        <div v-show="checkIsHaveImgs(item.metadata)" class="photo-container">
          <b-button ref="collapse" @click="showCollapsePhoto(index)" v-b-toggle="`collapse-${index}`" size="sm" class="mt-2" variant="outline-primary">Show Photo</b-button>
          <b-collapse :id="`collapse-${index}`" class="mt-2">
            <b-card>
              <b-carousel
                style="text-shadow: 1px 1px 2px #333;"
                controls
                indicators
                background="#ababab"
                img-width="480"
                img-height="480"
                :interval="4000">
                <b-carousel-slide v-for="(img, idx) in getImages(item.metadata)" :key="idx" :img-src="img">
                  <h1>{{getData(item.metadata, 'reason.d')}}</h1>
                </b-carousel-slide>
              </b-carousel>
            </b-card>
          </b-collapse>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { isEmpty, get } from 'lodash';
import * as Config from '@/config';

export default {
  data() {
    return {
      questions: [],
    };
  },
  created() {
    this.$store.dispatch('question_prestart/LOAD_DETAIL_DATA');
  },
  computed: {
    detailedInfo() {
      return this.$store.getters['question_prestart/get_detail_data'];
    },
  },
  watch: {
    detailedInfo(data) {
      const { answers } = data;
      this.questions = answers;
    },
  },
  methods: {
    getData(dt, key) {
      const value = get(dt, key) || '-';
      return value;
    },
    checkIsHaveImgs(data) {
      if (isEmpty(data)) {
        return false;
      }
      const imgUrls = get(data, 'reason.img_urls') || [];
      if (!imgUrls.length) return false;

      return true;
    },
    showCollapsePhoto(index) {
      const { innerText: text } = this.$refs.collapse[index];
      if (text === 'Show Photo') {
        this.$refs.collapse[index].innerText = 'Hide Photo';
      } else {
        this.$refs.collapse[index].innerText = 'Show Photo';
      }
    },
    getImages(metadata) {
      let images = [];

      const imgUrls = get(metadata, 'reason.img_urls') || [];
      images = imgUrls.map(url => `${get(Config, 'default.tmsGraphqlApiUrl')}/uploads/images/${url}`);

      return images;
    },
  },
};
</script>
<style>
  .carousel-inner {
    height: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/pages/question_prestart/detail/Questions.vue